//DBTables
// import { DBBuilding } from "../../types/DBTables";
import { Button, Form, Modal } from "react-bootstrap";
import { useCallback, useEffect, useRef, useState } from "react";
import { get, getAuthHeader, post, updateUserInfo } from "../../../modules/server";
import html2canvas from "html2canvas";
import Notify from "devextreme/ui/notify";
import HtmlEditor from "devextreme-react/html-editor";
import { getLog, logAndNotifyError, logAndNotifySuccess, logDebugSilently, LogEntry, logErrorSilently, logWarningSilently, notifyError, notifySuccess, notifyWarning } from "../../../modules/logger";
import { useGlobalData } from "../../GlobalDataProvider";
import { delayAsync } from "../../../modules/common";
import { API_URL } from "../../../constants";
import notify from "devextreme/ui/notify";
import HideToasts from "devextreme/ui/toast/hide_toasts";
import { useForm } from "react-hook-form";
import TextEditor from "../Editors/TextEditor";
import ValidationSummaryMessages from "../../Configuration/ValidationSummaryMessages";
import SelectEditor from "../Editors/SelectEditor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "../../../modules/Colors";

//interface IProps {}
interface BugReportFormData {
  description: string;
  reportType: "bug" | "feedback";
}

const SendBugOrFeedbackDialog = () => {
  //const globalData = useGlobalData();
  const [show, setShow] = useState(false);
  //const [description, setDescription] = useState("");
  // const [logs, setLogs] = useState<LogEntry[]>([]);
  const [screenshot, setScreenshot] = useState<string | null>(null);
  const [attachedFile, setAttachedFile] = useState<File | null>(null);

  const formHook = useForm({
    defaultValues: { reportType: "bug" } as any,
  });
  const {
    handleSubmit,
    formState: { errors },
  } = formHook;

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (!file) return;

      const validTypes = ["image/jpeg", "image/png"];
      if (!validTypes.includes(file.type)) {
        notifyWarning("Endast .jpg och .png filer är tillåtna.");
        e.target.value = ""; // Clear the input
        return;
      }

      setAttachedFile(e.target.files[0]);
    }
  };

  const handleClose = () => {
    setShow(false);
  };
  const scrollToTopAndWait = (timeout = 4000) => {
    //Promise that scrolls to the top and waits for it to finish (Or timeout...)
    return new Promise((resolve) => {
      const targetY = 0;
      let isAtTop = false;

      // Handler for scroll event
      const onScroll = () => {
        if (window.scrollY === targetY) {
          isAtTop = true;
          window.removeEventListener("scroll", onScroll);
          resolve(0);
        }
      };

      // Add scroll listener
      window.addEventListener("scroll", onScroll);

      // Start scroll
      window.scrollTo({ top: targetY, behavior: "smooth" });

      // Fallback timeout in case something breaks
      setTimeout(() => {
        if (!isAtTop) {
          window.removeEventListener("scroll", onScroll);
          resolve(-1);
        }
      }, timeout);
    });
  };

  useEffect(() => {
    PubSub.subscribe("ShowSendBugOrFeedbackDialog", async () => {
      formHook.reset();

      Notify(
        {
          message: "Ett ögonblick, samlar data...",
          height: 50,
          width: 250,
          minWidth: 150,
          type: "info",
          displayTime: 3500,
          animation: {
            show: {
              type: "fade",
              duration: 400,
              from: 0,
              to: 1,
            },
            hide: { type: "fade", duration: 40, to: 0 },
          },
        },
        {
          position: "top right",
          direction: "down-push",
        }
      );
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      try {
        if (window.scrollY !== 0) {
          //The screenshot only gets correct when the document is scrolled to the top. If it's not, scroll to the top and wait for it to finish.
          await scrollToTopAndWait();
        }

        //throw new Error("Test error"); //For testing error handling

        //HideToasts(); //Prevents double Toasts
        //Notify in the right corner, where the bug button resides. Prevents double clicks and does not too much disturb the captured screen.

        await delayAsync(100);

        let canvas;
        try {
          // Try normal capture first (cleanest, most accurate)
          canvas = await html2canvas(document.body, { useCORS: true });
        } catch (err) {
          logErrorSilently("Primary screenshot attempt failed, retrying with ignoreElements fallback", err);

          // Fallback with selective ignoring of problematic elements
          canvas = await html2canvas(document.body, {
            useCORS: true,
            ignoreElements: (el) => {
              const tag = el.tagName.toLowerCase();
              const rect = el.getBoundingClientRect();
              const isZero = rect.width === 0 || rect.height === 0;
              const isHidden = getComputedStyle(el).display === "none";
              const isSkippable = ["head", "noscript", "script", "style", "meta", "link"].includes(tag);
              return isZero && (isSkippable || isHidden);
            },
          });
        }

        setScreenshot(canvas.toDataURL("image/png"));
      } catch (err) {
        logErrorSilently("Failed to capture screenshot " + (isSafari ? "(on Safari)" : ""), err);
      }

      HideToasts();
      //notifySuccess("Ok, data insamlad", 2000);

      setShow(true);
    });

    return () => {
      //Unsubscribe on unmount, to avoid multiple subscriptions
      PubSub.unsubscribe("ShowSendBugOrFeedbackDialog");
    };
  }, []);

  const onSubmit = async (data: any) => {
    const formData = new FormData();
    formData.append("description", data.description);
    formData.append("reportType", data.reportType);

    if (screenshot) formData.append("screenshotBase64", screenshot);
    if (attachedFile) formData.append("attachedFile", attachedFile);

    const log = getLog();
    const logString = log.map((le) => `[${le.timestamp}] ${le.level}: ${le.message}`).join("\n");
    const blob = new Blob([logString], { type: "text/plain" });
    const virtualFile = new File([blob], "log.txt", { type: "text/plain" });

    formData.append("logFile", virtualFile);
    const headers = {
      ...{
        // "Access-Control-Allow-Headers": "*",
        // "Access-Control-Allow-Origin": "*",
      },
      ...(getAuthHeader() || {}),
    };
    try {
      const response = await fetch(API_URL + "SendBugReport", {
        method: "POST",
        mode: "cors",
        body: formData,
        headers: headers,
      });
      if (!response.ok) {
        let errorMessage = "Failed to send bug report: " + response.status;
        try {
          const errorResponse = await response.json();
          if (errorResponse && errorResponse.message) {
            errorMessage += " - " + errorResponse.message;
          }
        } catch (err2) {}
        throw new Error(errorMessage);
      }
      logAndNotifySuccess("Bug report sent successfully");
    } catch (err) {
      notifyError("Bug report failed:" + (err as Error).message);
      logErrorSilently("Failed to send bug report", err);
    }

    // Reset form
    formHook.reset(); // setDescription("");
    setAttachedFile(null);
    handleClose();
  };

  const log = getLog();
  return (
    <div style={{ display: show ? "block" : "none" }}>
      {show ? (
        <>
          <Modal show={show} onHide={handleClose} size="xl" centered={false} scrollable={true}>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Modal.Header closeButton className="bg-warning">
                <Modal.Title>Skicka feedback/bugg-rapport</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* <Form.Group className="mb-3" controlId="bugDescription">
                  <Form.Label>Beskriv problemet/idén etc:</Form.Label>
                  <Form.Control as="textarea" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Beskriv problemet/idén etc..." />
                </Form.Group> */}
                <Form.Group className="mb-3">
                  <SelectEditor
                    items={[
                      { id: "bug", text: "Bugg" },
                      { id: "feedback", text: "Feedback" },
                    ]}
                    label="Bugg / feedback :"
                    formHook={formHook}
                    fieldName="reportType"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <TextEditor
                    multiline={true}
                    label="Beskriv problemet/idén etc :"
                    formHook={formHook}
                    fieldName="description"
                    options={{
                      validate: {
                        required: (v) => {
                          return !v ? "Vänligen skriv något!" : undefined;
                        },
                      },
                    }}
                  />
                </Form.Group>

                {/* {screenshot && (
                  <div className="mb-3">
                    <Form.Label>Screenshot:</Form.Label>
                    <img src={screenshot} alt="Screenshot" style={{ width: "100%", border: "1px solid #ccc" }} />
                  </div>
                )} */}

                <Form.Group controlId="logFileUpload" className="mb-3">
                  <Form.Label>Bifoga bild (.jpg, .png)</Form.Label>
                  <Form.Control type="file" accept=".jpg,.png" onChange={handleFileChange} />
                </Form.Group>

                {/* <Form.Group>
                  <Form.Label>Log:</Form.Label>
                  <Form.Control as="textarea" readOnly rows={6} value={log.map((le) => `[${le.timestamp}] ${le.level}: ${le.message}`).join("\n")} />
                </Form.Group> */}

                <ValidationSummaryMessages errors={errors} />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Avbryt
                </Button>
                <Button variant="primary" type="submit">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2" style={{ color: Colors.YellowMedium }} />
                  Skicka
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </>
      ) : (
        <> </>
      )}
    </div>
  );
};

export default SendBugOrFeedbackDialog;
